module.exports = __webpack_public_path__ + "img/gift-box-coral.6e078a4d.svg";